import { PrioHealthErrorLevel } from '../../../models/Zendesk';
import {
  PrioHealthHighestErrorLevelAction,
  UPDATE_PRIO_HEALTH_HIGHEST_ERROR_LEVEL,
} from '../actions/prioHealthHighestErrorLevel';

export interface PrioHealthHighestErrorLevelState {
  highestErrorLevel: PrioHealthErrorLevel;
}
export const initialState: PrioHealthHighestErrorLevelState = {
  highestErrorLevel: null,
};

const reducer = (
  state = initialState,
  action: PrioHealthHighestErrorLevelAction
) => {
  switch (action.type) {
    case UPDATE_PRIO_HEALTH_HIGHEST_ERROR_LEVEL: {
      const { newState } = action;
      return {
        ...state,
        highestErrorLevel: newState.highestErrorLevel,
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getHighestErrorLevel = (
  state: PrioHealthHighestErrorLevelState
): PrioHealthErrorLevel => state.highestErrorLevel;
